export const accountPages = ['routes/_menu.$basename.account'];

export const authPages = [
  'routes/_menu.$basename.login._index',
  'routes/_menu.$basename.login.email',
  'routes/_menu.$basename.forgot-password',
  'routes/_menu.$basename.reset-password',
  'routes/_menu.$basename.signup',
];

export const customRowPages = [
  'routes/_menu.$basename.rows.$customRowId.$slug',
  'routes/_menu.$basename.store.$storeId.rows.$customRowId.$slug',
];

export const featuredPages = [
  'routes/_menu.$basename.featured._index',
  'routes/_menu.$basename.store.$storeId.featured._index',
];

export const categoryPages = [
  'routes/_menu.$basename.edible._index',
  'routes/_menu.$basename.extract._index',
  'routes/_menu.$basename.flower._index',
  'routes/_menu.$basename.gear._index',
  'routes/_menu.$basename.grow._index',
  'routes/_menu.$basename.merch._index',
  'routes/_menu.$basename.pre-roll._index',
  'routes/_menu.$basename.tincture._index',
  'routes/_menu.$basename.topical._index',
  'routes/_menu.$basename.vape._index',
  'routes/_menu.$basename.shop-all._index',

  'routes/_menu.$basename.store.$storeId.edible._index',
  'routes/_menu.$basename.store.$storeId.extract._index',
  'routes/_menu.$basename.store.$storeId.flower._index',
  'routes/_menu.$basename.store.$storeId.gear._index',
  'routes/_menu.$basename.store.$storeId.grow._index',
  'routes/_menu.$basename.store.$storeId.merch._index',
  'routes/_menu.$basename.store.$storeId.pre-roll._index',
  'routes/_menu.$basename.store.$storeId.tincture._index',
  'routes/_menu.$basename.store.$storeId.topical._index',
  'routes/_menu.$basename.store.$storeId.vape._index',
  'routes/_menu.$basename.store.$storeId.shop-all._index',
];

export const plpPages = [
  ...featuredPages,
  ...categoryPages,
  ...customRowPages,

  'routes/_menu.$basename.search',

  'routes/_menu.$basename.deals._index',
  'routes/_menu.$basename.deals.$dealId.$slug',
  'routes/_menu.$basename.jane-gold._index',
  'routes/_menu.$basename.jane-gold.$specialId.$slug',

  'routes/_menu.$basename.store.$storeId.deals._index',
  'routes/_menu.$basename.store.$storeId.deals.$dealId.$slug',
  'routes/_menu.$basename.store.$storeId.jane-gold._index',
  'routes/_menu.$basename.store.$storeId.jane-gold.$specialId.$slug',
];

export const pdpPages = ['routes/_menu.$basename.products.$productId.$slug'];
